import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Invoice } from '@/types';
    import DataTableActions from '@/components/datatable/DataTableActions.vue';
    import ContinueButton from '@/components/ContinueButton.vue';
    import { useI18n } from 'vue-i18n';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CustomerInvoicesTableActions',
  props: {
    invoice: {}
  },
  setup(__props: any) {

    const { t } = useI18n();

    const props = __props;

    const downloadInvoice = () => {
        window.open(
            route('v2.dashboard.invoices.download', { id: props.invoice.booked_invoice_number }),
            '_blank',
        );
    };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DataTableActions, { data: _ctx.invoice }, {
    default: _withCtx(() => [
      _createVNode(ContinueButton, { onClick: downloadInvoice }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('dashboards.invoices.download')), 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["data"]))
}
}

})